/* eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Flex,
  DatePicker,
  Tag,
  message,
  Tooltip,
  Spin
} from "antd";

import moment from "moment";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import { CustomTable } from "@/hocComponents";
import GLAccountModal from "./GlAccountModal";

const { RangePicker } = DatePicker;

const PaymentsTable = ({ refreshKey }) => {
  const [tableList, setTableList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [glModalVisible, setGlModalVisible] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [predictedDates, setPredictedDates] = useState(null);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  const [tableHead, setTableHead] = useState({
    status: 2,
    requestNo: null,
    propName: null,
    vendorName: null,
    quotedAmount: null,
    payAmount: null,
    payRemark: null,
    supervisor: null,
    addressCity: null,
    role: null,
    sReadyToPayDate: null,
    eReadyToPayDate: null,
  });

  // 获取列表数据
const getTableList = async (page, pageSize, params = tableHead) => {
  try {
    setLoading(true);
    const queryParams = new URLSearchParams({
      page: page,
      count: pageSize,
      prop: params?.prop || "",
      status: 2,
      requestNo: params?.requestNo || "",
      vendorName: params?.vendorName || "",
      quotedAmount: params?.quotedAmount || "",
      payAmount: params?.payAmount || "",
      payRemark: params?.payRemark || "",
      supervisor: params?.supervisor || "",
      addressCity: params?.addressCity || "",
      role: params.role || "",
      sReadyToPayDate: params.sReadyToPayDate || "",
      eReadyToPayDate: params.eReadyToPayDate || "",
      orderField: params.orderField || "",
      orderType: params.orderType || "",
    });

    const response = await http.get(
      `${api.getPayContractorShow}?${queryParams.toString()}`,
    );
    
    const dataWithKey = (response.data.list || []).map((item, index) => {
      return {
        ...item,
         key:item.id
      };
    });
    setTableList(dataWithKey);
    setPagination((prev) => ({
      ...prev,
      current: page,
      total: response.data.total,
      pageSize: pageSize,
    }));
  } catch (err) {
    message.error("Failed to fetch data");
  } finally {
    setLoading(false);
  }
};

  // 刷新
  const handleRefresh = () => {
    getTableList(pagination.current, pagination.pageSize, tableHead);
  };

  // 筛选
  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({
      event,
      key,
      type,
      setTableHead,
      getTableListFn: getTableList,
      pagination,
    });
  };

  // 分页变化
  const handleTableChange = (newPagination, filters, sorter) => {
    let orderField = "";
    let orderType = "";
    if (sorter && sorter.field) {
      orderField = sorter.field;
      orderType = sorter.order === "ascend" ? "asc" : "desc";
    }
    getTableList(newPagination.current, newPagination.pageSize, {
      ...tableHead,
      orderField,
      orderType,
    });
  };

  // GL Account Modal
  const handleOpenModal = (record) => {
    setSelectedRow(record);
    setGlModalVisible(true);
  };

  // details跳转
  const showModalOpen = (record) => {
    const params = record;
    const baseUrl = window.location.origin;
    const route = "/AccountPayable/MaintenancePayContractor/Details";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const showOpen = (record) => {
    const params = record;
    const baseUrl = window.location.origin;
    const route = "/AccountPayable/MaintenancePayPUT";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };
  const sendFn = async () => {
    if (!selectedRowKeys.length) {
      message.warning("Please select at least one item.");
      return;
    }
    Modal.confirm({
      title: "Send For Approval",
      icon: <ExclamationCircleOutlined />,
      content: `Are you sure you send for approval the selected data?`,
      okText: "Sure",
      cancelText: "Cancel",
      onOk: async () => {
        const query = qs.stringify(
          { idList: selectedRowKeys },
          { arrayFormat: "comma" },
        );
        try {
          const response = await http.get(`${api.getToVendorPayment}?${query}`);
          if (response.code === "1") {
            message.success("Send For Approval Successfully!");
            setSelectedRowKeys([]);
            getTableList(pagination.current, pagination.pageSize);
          } else {
            commonFn.modalFailedFn(response);
          }
        } catch (error) {
          message.error("Request failed");
        }
      },
      onCancel() {},
      style: { top: "40%" },
    });
  };
  const badgeFn = (record, item) => {
    const fnMatch = {
      Prop: (record) => {
        showOpen({
          propId: record.propId,
          type: "Prop",
        });
      },
      Unit: (record) =>
        showOpen({
          propId: record.propId,
          unitId: record.unitId,
          type: "Unit",
        }),
      Tenant: (record) =>
        showOpen({
          propId: record.propId,
          unitId: record.unitId,
          tenantId: record.tenantId,
          type: "Tenant",
        }),
    };
    if (fnMatch[item.key]) {
      fnMatch[item.key](record);
    }
  };

  // 列定义
  const getColumns = () => {
    const baseColumns = [
      {
        title: "Vendor Name",
        dataIndex: "vendorName",
        key: "vendorName",
        hidden: false,
        width: 110,
        align: "center",
        titleType: "Input",
        onChange: (e) => tableFilterFn(e, "vendorName"),
      },
      {
        title: "Status",
        dataIndex: "vpStatus",
        key: "vpStatus",
        align: "center",
        hidden: false,
        width: 100,
        className: "custom-sort-header",
        render: (text, record) => {
          let statusText = "";
          let tagColor = "";
          if (text === "Ready To Pay") {
            statusText = "Ready To Pay";
            tagColor = "#00a65a";
          } else if (text === "Sent to Check Approval") {
            statusText = "Sent to Check Approval";
            tagColor = "#3c8dbc";
          } else if (text === "Rejected") {
            statusText = "Rejected";
            tagColor = "#dd4b39";
          } else if (text === "Approved to Print") {
            statusText = "Approved to Print";
            tagColor = "#2563EB";
          } else if (text === "Do not Pay") {
            statusText = "Do not Pay";
            tagColor = "#71baeb";
          }
          return (
            <a onClick={() => showModalOpen(record)} style={{ cursor: "pointer" }}>
              <Tag
                color={tagColor}
                style={{
                  color: "#fff",
                  borderRadius: "4px",
                  padding: "0 8px",
                }}
              >
                {statusText}
              </Tag>
            </a>
          );
        },
      },
      {
        title: "Vendor Type",
        dataIndex: "role",
        key: "role",
        hidden: false,
        titleType: "Input",
        onChange: (e) => tableFilterFn(e, "role"),
        width: 100,
      },
      {
        title: "Request No",
        dataIndex: "requestNo",
        key: "requestNo",
        hidden: false,
        titleType: "Input",
        onChange: (e) => tableFilterFn(e, "requestNo"),
        width: 100,
      },
      {
        title: "Unit Address, City",
        dataIndex: "addressCity",
        key: "addressCity",
        hidden: false,
        titleType: "Input",
        onChange: (e) => tableFilterFn(e, "addressCity"),
        width: 100,
      },
      {
        title: "Job",
        dataIndex: "jobs",
        titleType: "Input",
        width: 100,
        sortterMultiple: 3,
        onChange: (e) => tableFilterFn(e, "jobs"),
        render: (text, record) => {
          return (
            <Flex
              gap="4px 0"
              wrap
              justify="center"
              align="center"
              style={{ width: "100%", textAlign: "center" }}
            >
              {record.jobs.map((item, idx) => (
                <Tooltip title={` ${item}`} classNames="my-tooltip" key={idx}>
                  <Tag
                    color="#2563EB"
                    style={{
                      color: "#ffffffff",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {item}
                  </Tag>
                </Tooltip>
              ))}
            </Flex>
          );
        },
      },
      {
        title: "GL Acct",
        dataIndex: "glAcct",
        titleType: "Input",
        width: 100,
        sortterMultiple: 3,
        onChange: (e) => tableFilterFn(e, "glAcct"),
        render: (text) => <span>{text || ""}</span>,
      },
      {
        title: "Quoted Amount",
        dataIndex: "quotedAmount",
        key: "quotedAmount",
        hidden: false,
        width: 100,
        titleType: "Input",
        onChange: (e) => tableFilterFn(e, "quotedAmount"),
        render: commonFn.amountToDollarFn,
      },
      {
        title: "Pay Amount",
        dataIndex: "payAmount",
        key: "payAmount",
        width: 100,
        hidden: false,
        titleType: "Input",
        onChange: (e) => tableFilterFn(e, "payAmount"),
        render: (text) => <span>{commonFn.amountToDollarFn(text)}</span>,
      },
      {
        title: "Pay Remark",
        dataIndex: "payRemark",
        key: "payRemark",
        hidden: false,
        titleType: "Input",
        onChange: (e) => tableFilterFn(e, "payRemark"),
        width: 100,
      },
      {
        title: "Supervisor",
        dataIndex: "supervisor",
        key: "supervisor",
        hidden: false,
        isDate: true,
        titleType: "Input",
        onChange: (e) => tableFilterFn(e, "supervisor"),
        width: 100,
      },
      {
        title: "Ready To Pay Date",
        dataIndex: "payTime",
        key: "payTime",
        width: 150,
        sorter: true,
        render: (text) => (text ? moment(text).format("MM/DD/YYYY") : ""),
      },
    ];

    return commonFn.handleColunmFn(baseColumns);
  };

  const columns = getColumns();

  useEffect(() => {
    getTableList(1, 25, { ...tableHead, status: 2 });
  }, [refreshKey]);

return (
    <>
      {/* {commonFn.btnAuthorityFlag("SendForApproval") && (
        <div style={{ marginBottom: 10, marginTop: -10 }}>
          {commonFn.btnDocFn({
            name: "Send For Approval",
            noShowIcon: true,
            btnFn: sendFn,
          })}
        </div>
      )} */}

      <Spin spinning={loading} tip="Loading...">
        <CustomTable
          loading={loading}
          columns={columns.filter((col) => col.hidden === false)}
          tableList={tableList}
          pagination={{
            showQuickJumper: true,
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            showSizeChanger: true,
            showTotal: (total) => `Total: ${total} items`,
          }}
          rowKey="key" 
          onChange={handleTableChange}
               setTableHead={setTableHead}  
            getTableListFn={getTableList}
          hideSelectAll={true}
          rowSelection={{
            type: "checkbox",
            selectedRowKeys: selectedRowKeys,
            getCheckboxProps: (record) => ({
              disabled: record.status === 2 || record.glAcct === null,
            }),
            onChange: (selectedRowKeys) => {
              setSelectedRowKeys(selectedRowKeys);
            },
          }}
          tableScrollY="320px"
        />
      </Spin>

      <GLAccountModal
        visible={glModalVisible}
        onClose={() => setGlModalVisible(false)}
        selectedRow={selectedRow}
        onSuccess={() => {
          getTableList(pagination.current, pagination.pageSize, tableHead);
        }}
        getTableListFn={getTableList}
        pagination={pagination}
      />
    </>
  );
};

export default PaymentsTable;